import React from 'react';
import { faShoppingBag } from '@fortawesome/free-solid-svg-icons';
import { Col, Row } from 'react-bootstrap';
import ShieldSvg from '@components/Footer/ShieldSvg';
import BannerIcon from '@components/Footer/BannerIcon';
import styles from '@components/Footer/Footer.module.scss';
import { useIsFeatureEnabled } from '@/services/feature-toggles-service';

export default function Banner() {
  const uspFeature = useIsFeatureEnabled('mcl:footer-usps');

  return (
    <>
      <ul className="d-none d-xl-flex text-center align-items-end">
        <Col xs={2} as="li">
          {uspFeature && <BannerIcon icon={faShoppingBag} link={'/'} text={'One stop shop'} />}
        </Col>
        <Col xs={2} as="li">
          {uspFeature && <BannerIcon icon={faShoppingBag} link={'/'} text={'125 jaar ervaring'} />}
        </Col>

        <Col xs={4} as="li">
          <ShieldSvg />
        </Col>

        <Col xs={2} as="li">
          {uspFeature && <BannerIcon icon={faShoppingBag} link={'/'} text={'Snel en deskundig'} />}
        </Col>
        <Col xs={2} as="li">
          {uspFeature && <BannerIcon icon={faShoppingBag} link={'/'} text={'Online bestelgemak'} />}
        </Col>
      </ul>

      <div className="d-xl-none">
        <div className={`${styles.smallShield} text-center`}>
          <ShieldSvg />
        </div>
        {uspFeature && (
          <>
            <Row className="mb-2 mt-5 ml-1">
              <Col>
                <BannerIcon icon={faShoppingBag} link={'/'} text={'Online bestelgemak'} />
              </Col>
              <Col>
                <BannerIcon icon={faShoppingBag} link={'/'} text={'125 jaar ervaring'} />
              </Col>
            </Row>
            <Row className="ml-1">
              <Col>
                <BannerIcon icon={faShoppingBag} link={'/'} text={'Online bestelgemak'} />
              </Col>
              <Col>
                <BannerIcon icon={faShoppingBag} link={'/'} text={'Snel en deskundig'} />
              </Col>
            </Row>
          </>
        )}
      </div>
    </>
  );
}
